export const emulatorVersion = '1.0.2';
